import { PaymentTypeEnum } from "@repo/core/enums/payments";
import { CardConsultDataResponseDTO } from "@repo/core/services/entities/Card";
import { ConsultProfileClientResponseDTO } from "@repo/core/services/entities/Client";

export const getTitle = (paymentType: PaymentTypeEnum) =>
  ({
    [PaymentTypeEnum.DEAL]: "Pagamento de Acordo",
    [PaymentTypeEnum.INVOICE]: "Pagamento de Fatura"
  })[paymentType];

export const getInvoiceMinValue = (
  invoiceInfo?: CardConsultDataResponseDTO["objFatura"]
) => {
  if (!invoiceInfo?.dblValorMinimo) {
    return null;
  }

  if (invoiceInfo.dblValorMinimo > 0) {
    return invoiceInfo.dblValorMinimo;
  }

  if (invoiceInfo.dblValorMinimo < 0) {
    return invoiceInfo.dblValorMinimo * -1;
  }
};

export const getInvoiceMaxValue = (
  invoiceInfo?: CardConsultDataResponseDTO["objFatura"]
) => {
  if (!invoiceInfo) {
    return null;
  }

  if (invoiceInfo.dblValor > 0) {
    return invoiceInfo.dblValor;
  }

  if (invoiceInfo.dblValor < 0) {
    return invoiceInfo.dblValor * -1;
  }
};

export const getDealMinValue = (
  dealInfo?: ConsultProfileClientResponseDTO[0]["lstAcordos"][0]
) => {
  if (!dealInfo) {
    return null;
  }

  if (dealInfo.dblValorEntrada > 0) {
    return dealInfo.dblValorEntrada;
  }

  if (dealInfo.dblValorEntrada < 0) {
    return dealInfo.dblValorEntrada * -1;
  }
};
